module.exports = __webpack_public_path__ + "static/images/expand.G33SyH1.svg";